import { emailRegex } from "../_utils/regex";

const processFields = (fields) => {
  const emptyFields = fields
    ? Object.keys(fields).filter((key) => !fields[key])
    : [];
  const emptyFieldsString =
    emptyFields.length > 0 ? `Missing fields: ${emptyFields.join(", ")}` : "";
  return { emptyFields, emptyFieldsString };
};

const validateEmail = (email) => emailRegex.test(email);

const processResponse = async (responsePromise) => {
  const res = await responsePromise;

  if (!res.ok) {
    throw new Error(`Server responded with status: ${res.status}`);
  }

  if (res.status === 202) {
    return { message: "Request is being processed.", code: 202 };
  }

  // Check if there is any content to parse
  const contentType = res.headers.get("Content-Type");
  if (contentType && contentType.includes("application/json")) {
    try {
      const responseData = await res.json();
      return responseData;
    } catch (error) {
      console.error("Error parsing JSON:", error);
      throw new Error("Failed to parse response.");
    }
  } else {
    console.log("No JSON content to parse or unexpected content type.");
    return null;
  }
};

export const subscribe = async (fields, params = {}) => {
  const { emptyFields, emptyFieldsString } = processFields(fields);
  if (emptyFields.length) return { error: emptyFieldsString };

  const { email, listId, companyId } = fields;
  if (!validateEmail(email)) return { error: "Invalid email address" };

  const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`;
  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      revision: "2024-07-15",
      "content-type": "application/json",
    },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { properties: params, email },
            },
          },
        },
        relationships: { list: { data: { type: "list", id: listId } } },
      },
    }),
  };

  try {
    const response = await fetch(url, options);
    return processResponse(response);
  } catch (error) {
    console.error("Network or other error:", error);
    return { error: error.message || "Unknown error occurred" };
  }
};

export const subscribeBackInStock = async (fields) => {
  const { emptyFields, emptyFieldsString } = processFields(fields);
  if (emptyFields.length) return { error: emptyFieldsString };

  const { email, variantId, companyId } = fields;
  if (!validateEmail(email)) return { error: "Invalid email address" };

  const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`;
  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      revision: "2024-07-15",
      "content-type": "application/json",
    },
    body: JSON.stringify({
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: { data: { type: "profile", attributes: { email } } },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }),
  };

  try {
    const response = await fetch(url, options);
    return processResponse(response);
  } catch (error) {
    console.error("Network or other error:", error);
    return { error: error.message || "Unknown error occurred" };
  }
};
